// write the boiler plate code
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sdSupportSearchBaseURL,newSdGroupApiBaseURL } from '../../constants/index';
import axios from 'axios';


const initialState = {
    search: {
        searchResults: [],
        isLoading: false,
        error: null,
    },
    productCarousel: {
        products: [],
        isLoading: false,
        error: null,
    },
    suggestion: {
        knowledgeBase: [],
        product: [],
        productDoc: [],
        software: [],
        community: [],
        isLoading: false,
        nodata: false
    }
};

export const getSearchResults = createAsyncThunk('supportSearchSlice/getSearchResults', async (query) => {
    try {

        return await axios.get(sdSupportSearchBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});
export const getProducts = createAsyncThunk('supportSearchSlice/getProducts', async (query) => {
    try {
        return await axios.get(sdSupportSearchBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getSuggestion = createAsyncThunk('supportSearchSlice/getSuggestion', async (query) => {
    try {
        return await axios.get(newSdGroupApiBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

const supportSearchSlice = createSlice({
    name: 'supportSearchSlice',
    initialState,
    reducers: {
        resetSearchPage: (state) => {
            state.search.searchResults = {};
        },
        resetFacet: (state) => {
            state.filterResult = {};
        },
        searchLoading: (state)=> {
            state.search.searchResults = {};
            state.search.searchResults.isLoading = true
        },
        resetProductList: (state) => {
            state.productCarousel = {};
        },
        resetSuggestion: (state) =>{
            state.suggestion.knowledgeBase=[]
            state.suggestion.product=[]
            state.suggestion.productDoc=[]
            state.suggestion.software=[]
            state.suggestion.community=[]
            state.suggestion.isLoading=false
            state.suggestion.nodata=false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSearchResults.pending, (state) => {
                state.search.isLoading = true;
            })
            .addCase(getSearchResults.fulfilled, (state, action) => {
                state.search.isLoading = false;
                state.search.searchResults = action.payload;
            })
            .addCase(getSearchResults.rejected, (state, action) => {
                state.search.isLoading = false;
                state.search.error = action.error.message;
            })
            .addCase(getProducts.pending, (state) => {
                state.productCarousel.isLoading = true;
            })
            .addCase(getProducts.fulfilled, (state, action) => {
                state.productCarousel.isLoading = false;
                state.productCarousel.products = action.payload;
            })
            .addCase(getProducts.rejected, (state, action) => {
                state.productCarousel.isLoading = false;
                state.productCarousel.error = action.error.message;
            })
            .addCase(getSuggestion.pending, (state) => {
                state.suggestion.isLoading = true;
            })
            .addCase(getSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                let data=action?.payload?.grouped_docs
                if(data){
                    if (data["Knowledge Base"]) {
                        state.suggestion.knowledgeBase=data["Knowledge Base"].slice(0, 3)
                      }
                      if (data["Support Products"]) {
                        state.suggestion.product=data["Support Products"]
                      }
                      if (data["Documents"]) {
                        state.suggestion.productDoc=data["Documents"].slice(0, 3)
                      }
                      if (data["Software Downloads"]) {
                        state.suggestion.software=data["Software Downloads"].slice(0, 3)
                      }
                      if (data["Community"]) {
                        state.suggestion.community=data["Community"].slice(0, 3)
                      }
                }
                if(state.suggestion.knowledgeBase.length===0 
                    && state.suggestion.product.length===0
                    && state.suggestion.productDoc.length===0
                    && state.suggestion.software.length===0
                    && state.suggestion.community.length===0
                    ){
                    state.suggestion.nodata=true
                }
                state.suggestion.isLoading = false;
            })
            .addCase(getSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.suggestion.isLoading = false;
                state.search.error = action.error.message;
            });
    },
});

export const { resetProductList,resetSearchPage,resetSuggestion, searchLoading,resetFacet } = supportSearchSlice.actions;

export default supportSearchSlice.reducer;
